import { ThunkAction as ThunkActionCreator } from 'redux-thunk';
import { AnyAction } from 'redux';
import { SnackbarKey } from 'notistack';
import {
    AppStore,
    INotification,
    Order,
    Store,
    TableEvent,
    WorkingHours
} from '../types';

export enum ActionType {
    SET_OPEN_ORDERS = 'SET_OPEN_ORDERS',
    SET_PRODUCTS = 'SET_PRODUCTS',
    SET_TABLES = 'SET_TABLES',
    SET_USER = 'SET_USER',
    SET_TABLE_EVENTS = 'SET_TABLE_EVENTS',
    SET_NOT_DISPATCHED_ORDERS = 'SET_NOT_DISPATCHED_ORDERS',
    SET_CONNECTION = 'SET_CONNECTION',
    ADD_ORDER = 'ADD_ORDER',
    ADD_TABLE_EVENT = 'ADD_TABLE_EVENT',
    SET_ORDER_COMPLETED = 'SET_ORDER_COMPLETED',
    SET_WORKING_HOURS = 'SET_WORKING_HOURS',
    REMOVE_TABLE_EVENT = 'REMOVE_TABLE_EVENT',
    SET_SELECTED_TABLE_ORDER = 'SET_SELECTED_TABLE_ORDER',
    SET_ORDER_DELIVERED = 'SET_ORDER_DELIVERED',
    RESET_STATE = 'RESET_STATE',
    REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION',
    ENQUEUE_NOTIFICATION = 'ENQUEUE_NOTIFICATION',
    FREE_TABLE = 'FREE_TABLE'
}

interface CloseNotification {
    type: ActionType.REMOVE_NOTIFICATION;
    payload: SnackbarKey;
}

interface EnqueueNotification {
    type: ActionType.ENQUEUE_NOTIFICATION;
    payload: INotification;
}

interface SetProducts {
    type: ActionType.SET_PRODUCTS;
    payload: AppStore['products'];
}

interface SetOrders {
    type: ActionType.SET_OPEN_ORDERS;
    payload: AppStore['openOrders'];
}

interface SetNotDispatchedOrders {
    type: ActionType.SET_NOT_DISPATCHED_ORDERS;
    payload: AppStore['notDispatchedOrders'];
}

interface SetTables {
    type: ActionType.SET_TABLES;
    payload: AppStore['tables'];
}

interface SetUser {
    type: ActionType.SET_USER;
    payload: AppStore['user'];
}

interface SetTableEvents {
    type: ActionType.SET_TABLE_EVENTS;
    payload: AppStore['tableEvents'];
}

interface AddOrder {
    type: ActionType.ADD_ORDER;
    payload: Order;
}

interface AddTableEvent {
    type: ActionType.ADD_TABLE_EVENT;
    payload: TableEvent;
}

interface SetOrderCompleted {
    type: ActionType.SET_ORDER_COMPLETED;
    payload: Order;
}

interface SetWorkingHours {
    type: ActionType.SET_WORKING_HOURS;
    payload: WorkingHours[];
}

interface RemoveTableEvent {
    type: ActionType.REMOVE_TABLE_EVENT;
    payload: number;
}

interface SetSelectedTableOrder {
    type: ActionType.SET_SELECTED_TABLE_ORDER;
    payload: Order;
}

interface ResetState {
    type: ActionType.RESET_STATE;
}

interface SetConnection {
    type: ActionType.SET_CONNECTION;
    payload: AppStore['connection'];
}

interface SetOrderDelivered {
    type: ActionType.SET_ORDER_DELIVERED;
    payload: Order;
}

interface FreeTable {
    type: ActionType.FREE_TABLE;
    payload: number;
}

export type Action =
    | SetOrders
    | SetProducts
    | SetTables
    | SetUser
    | SetTableEvents
    | SetNotDispatchedOrders
    | AddOrder
    | SetOrderCompleted
    | SetWorkingHours
    | AddTableEvent
    | RemoveTableEvent
    | SetSelectedTableOrder
    | ResetState
    | CloseNotification
    | EnqueueNotification
    | SetConnection
    | SetOrderDelivered
    | FreeTable;

export type ThunkAction<R = void> = ThunkActionCreator<R, Store, unknown, AnyAction>;
